<div *ngIf="isLoading" class="ltms-loading">
  <app-ltms-loader></app-ltms-loader>
</div>
<ng-container *ngIf="!isLoading">
  <router-outlet></router-outlet>
  <ng-toast></ng-toast>
  <litmus-alert></litmus-alert>
  <ltms-toast></ltms-toast>
  <div class="event-prevent" [class.enabled]="enableEventPrevention"></div>
  <div
    class="modal modal-dialog-centered usr-setting-landing-pop-up"
    id="sessionTimeOut"
    role="dialog"
    *ngIf="showModel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content usr-setting-pop-up-field">
        <div class="modal-header">
          <span class="modal-title usr-setting-pop-up-header">
            You have been signed out
          </span>
          <!-- <button type="button" class="btn-close" (click)="closeModal()"></button> -->
        </div>
        <div class="modal-body usr-setting-pop-up-summary">
          You have been signed out of the LitmusWorld Dashboard, and all sessions across tabs have been terminated.
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn save-usr-profile-btn"
            (click)="loginAgain()"
          >
            Sign in
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal-overlay" *ngIf="!enableDashboard"></div>
  <div class="no-connection-banner" *ngIf="!enableDashboard">
    Unable to reach the server. Please check your internet connection and try
    again.
  </div> -->
</ng-container>
